import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { LoadingState } from '@atlassian/notification-common/types';
function createRenderable(loadingStates, notifications, contentNotifications, converterFn) {
  var withoutContentLoaded = loadingStates.withoutContent === LoadingState.COMPLETE;
  var withContentLoaded = loadingStates.withContent === LoadingState.COMPLETE;
  var withContentError = loadingStates.withContent === LoadingState.ERROR;

  // Content loaded
  if (withContentLoaded) {
    return converterFn(contentNotifications, LoadingState.COMPLETE);

    // Content errored but notifications loaded
  } else if (withContentError && withoutContentLoaded) {
    return converterFn(notifications, LoadingState.ERROR);

    // Just notifications loaded (content still loading)
  } else if (withoutContentLoaded) {
    return converterFn(notifications, LoadingState.LOADING);
    // Fall through - could still be loading or both erroring.
  }
  return [];
}
export default function createRenderableNotifications(loadingStates, notifications, contentNotifications) {
  return createRenderable(loadingStates, notifications, contentNotifications, convertToRenderableNotifications);
}
export function createRenderableNotificationGroups(loadingStates, notifications, contentNotifications) {
  return createRenderable(loadingStates, notifications, contentNotifications, convertToRenderableNotificationGroups);
}
export function convertToRenderableNotificationGroups(groups, loadingState) {
  return groups.map(function (group) {
    return _objectSpread(_objectSpread({}, group), {}, {
      notifications: convertToRenderableNotifications(group.notifications, loadingState)
    });
  });
}
export var convertToRenderableNotifications = function convertToRenderableNotifications(notifications, loadingState) {
  return notifications.map(function (notif) {
    return _objectSpread(_objectSpread({}, notif), {}, {
      loadingState: loadingState
    });
  });
};